import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormFieldComponent } from '../../../../core/components/form-field/form-field.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SocketService } from '@core/services/socket.service';
import { ModalService } from '@core/modals/services/modal.service';
import { AdminFilterService } from '@features/admin/admin-filter/admin-filter.service';

@Component({
  selector: 'app-admin-add-filter-modal',
  imports: [FormFieldComponent, ReactiveFormsModule],
  templateUrl: './admin-add-filter-modal.component.html',
  styleUrl: './admin-add-filter-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class AdminAddFilterModalComponent {
  private readonly toastrService = inject(ToastrService);
  private readonly modalService = inject(ModalService);
  public readonly adminFilterService = inject(AdminFilterService);

  phrase = new FormControl<string>('', [Validators.required]);
  auto = new FormControl<number | null>(null);

  muteForm = new FormGroup({
    phrase: this.phrase,
    auto: this.auto,
  });

  async onSubmit() {
    this.muteForm.markAllAsTouched();

    if (!this.muteForm.valid) {
      this.toastrService.error('Form is not valid. Please check the inputs.');
      return;
    }

    const phrase = this.muteForm.get('phrase')?.value;
    const auto = this.muteForm.get('auto')?.value;

    if (!phrase) {
      this.toastrService.error('Phrase is required');
      return;
    }

    try {
      await this.adminFilterService.addFilter(phrase, auto);
      this.toastrService.success('Filter has been added successfully');
      this.modalService.close();
    } catch (error) {
      this.toastrService.error('Failed to add filter. Please try again.');
    }
  }
}
